import { render, staticRenderFns } from "./OutagesMessages.vue?vue&type=template&id=2723b4ae"
import script from "./OutagesMessages.vue?vue&type=script&lang=js"
export * from "./OutagesMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports